import { Link } from 'react-router-dom';
import { Carousel } from 'src/components/carousel/carousel';
import { EVENTS } from 'src/constants/routes';

import Item from 'src/pages/events/list/item';
import { EventListItem } from 'src/types/events';
import css from './events-section.module.scss';
import { useGetEvents } from '../data/queries';
import { ReactComponent as EventLinkIcon } from 'src/assets/event-arrow.svg';

export default function EventsSection() {
  const { data: events = [] } = useGetEvents();

  if (events?.length === 0) return null;

  return (
    <div className={css.eventsSection}>
      <div className={css.container}>
        <Carousel
          data={events.map((e: EventListItem) => (
            <Item
              event={{ ...e, slug: `${EVENTS.relativePath}/${e.slug}` }}
              key={`${e.id} - ${e.scheduledAt}`}
              showDate={true}
            />
          ))}
          title={
            <div className={css.header}>
              <Link to={EVENTS.path}>
                <p>Всі події</p> <EventLinkIcon />
              </Link>
              <h3>Найближчі події</h3>
            </div>
          }
          itemsToShow={events.length >= 3 ? 3 : events.length}
        />
      </div>
    </div>
  );
}
